var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "components-wrap", attrs: { id: "components-wrap" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "videosize",
              rawName: "v-videosize",
              value: { ratio: _vm.ratio, marginY: 0, marginX: 0 },
              expression: "{ ratio, marginY: 0, marginX: 0 }"
            }
          ],
          staticClass: "video-size-wrap"
        },
        _vm._l(_vm.compsList, function(item) {
          return _c(
            "V" + item.componentId,
            _vm._b(
              {
                key: item.id,
                tag: "component",
                attrs: {
                  nodeid: item.id,
                  tplid: item.componentId,
                  isGlobal: item.isGlobal,
                  root: "true"
                },
                on: {
                  interruptdestroy: function($event) {
                    return _vm.handleInterrupt(item.id)
                  },
                  requestdestroy: function($event) {
                    return _vm.handleRequest(item.id)
                  }
                }
              },
              "component",
              _vm.propsData[item.id],
              false
            )
          )
        }),
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }